import { Content } from '../../types';

export const huaHinContent: Content = {
  title: 'הואה הין – יעד נופש ייחודי בתאילנד',
  imageUrl: '/images/thailand/hua-hin/hua-hin-wide.jpeg',
  introduction:
    'הואה הין, הינה אחת מערי הנופש המרכזיות והמתפתחות בתאילנד והשקטה והנינוחה שמביניהן, שוכנת בצידו המערבי של מפרץ תאילנד, במחוז Prachuap Khiri Khan, במרחק של כ-2.5 שעות נסיעה דרומית-מערבית לבנגקוק.\n\nעיר זו מהווה יעד פופולרי, הן עבור תיירים מכל רחבי העולם והן עבור המקומיים, לרבות בית המלוכה התאילנדי, שבחר בהואה הין כמיקום לארמון הקיץ המלכותי.',
  sections: [
    {
      title: 'מה הופך את הואה הין ליעד מושלם לנופש?',
      description: `הואה הין מציעה שילוב ייחודי של נוחות מודרנית עם אווירה רגועה ונעימה. היא ידועה בניקיונה ובתחזוקה הקפדנית שלה ומציעה מגוון רחב של אפשרויות לתיירים:`,
      type: 'sub-headers',
      content: [
        {
          subtitle: 'בתי מלון וריזורטים',
          text: 'החל ממלונות יוקרה ועד גסטהאוסים משפחתיים.',
        },
        {
          subtitle: 'שווקים צבעוניים',
          text: 'דגש מיוחד על שווקי לילה אותנטיים (שווקי סופ"ש) כמו Cicada Market ו -Tamarind Market  וכמובן, שוק הלילה הוותיק והיומיומי של העיר.',
        },
        {
          subtitle: 'חופים רחבים ומרהיבים',
          text: 'מתאימים לרגיעה, ספורט ימי ורכיבה על סוסים.',
        },
        {
          subtitle: 'פארקי מים',
          text: 'כ -  Vana Nava Water Jungle ו-Black Mountain Water Park שמתאימים לכל המשפחה.',
        },
        {
          subtitle: 'קניונים ומרכזי קניות',
          text: 'כולל מתחם אאוטלט רחב הנמצא בסמוך לכביש הראשי לבנגקוק.',
        },
        {
          subtitle: "מכוני מסאז' וספא",
          text: "מגוון רחב של מקומות לטיפולי מסאז' תאילנדי מסורתי.",
        },
        {
          subtitle: 'אטרקציות תיירותיות',
          text: 'בעיר ובסביבתה ישנן מגוון פעילויות מרתקות המתאימות לכל סוגי המטיילים.',
        },
      ],
    },
    {
      title: 'שמורות טבע עוצרות נשימה',
      type: 'sub-headers',
      description: '',
      content: [
        {
          subtitle: 'Kaeng Krachan',
          text: 'שמורת הטבע הגדולה ביותר בתאילנד, אידיאלית לטיולי טבע וצפייה בחיות בר.',
        },
        {
          subtitle: 'Sam Roi Yot',
          text: 'שמורה מרהיבה הכוללת את מערת Phraya Nakhon, הידועה באולם הענק שלה ובקרן האור החודרת אליו מלמעלה.',
        },
      ],
    },
    {
      title: 'אתרים בולטים בעיר ובקרבתה',
      type: 'sub-headers',
      description: '',
      content: [
        {
          subtitle: 'Wat Huay Mongkol',
          text: 'מקדש מרשים בו נמצא פסל ענק של הנזיר הנערץ Luang Pu Taud.',
        },
        {
          subtitle: 'Khao Takiab',
          text: 'גבעה גבוהה המשקיפה על העיר והים, הידועה גם בשם "מקדש הקופים" בשל כמות הקופים הגדולה החיה בה.',
        },
        {
          subtitle: 'העיר העתיקה',
          text: 'אזור עם מבני עץ היסטוריים המאכלסים מסעדות, חנויות ובתי מלון קטנים.',
        },
        {
          subtitle: 'כפר הדייגים העתיק',
          text: 'מקום קסום המשמר את ההיסטוריה של העיר, עם אפשרות ליהנות ממסעדות דגים טריים.',
        },
        {
          subtitle: 'Walking Street',
          text: 'מתחם חיי לילה רגוע יחסית בהשוואה לערים אחרות כמו פטאיה.',
        },
      ],
    },
    {
      title: 'מתי כדאי לבקר בהואה הין?',
      content:
        'הואה הין, הינה יעד נהדר לכל אורך השנה, בזכות האקלים הטרופי המתון שלה. כמות המשקעים נמוכה יחסית, אם כי החודשים הגשומים ביותר הם נובמבר-דצמבר.',
      type: 'text',
    },
    {
      title: 'איך להגיע להואה הין?',
      type: 'sub-headers',
      description: 'ההגעה לעיר פשוטה ונוחה ממגוון מקומות:',
      content: [
        {
          subtitle: 'מבנגקוק',
          text: 'באמצעות רכב פרטי, מונית, מיניבוס, רכבת או אוטובוס.',
        },
        {
          subtitle: 'משדה התעופה Suvarnabhumi (BKK)',
          text: 'קיימות הסעות ישירות מהשדה להואה הין.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        'הובשורה התחתונה, אם פטאיה הינה עיר הנופש הרועשת והתוססת של תאילנד, הרי שהואה הין מציעה אלטרנטיבה רגועה, נעימה ובטוחה יותר. היא מתאימה במיוחד למשפחות, זוגות ולכל מי שמחפש חופשה בתאילנד עם שילוב של חופים, טבע ותרבות מקומית.',
      type: 'text',
      isBold: true,
    },
  ],
};
